import React from 'react';
import PropTypes from 'prop-types';

export default function File({ field, form: { setFieldValue }, accept }) {
  return (
    <input
      {...field}
      type='file'
      accept={accept}
      onChange={(e) => setFieldValue(`${ field.name }`, e.currentTarget.files[0])}
    />
  );
}

File.defaultProps = {
  accept: '*',
};

File.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  accept: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};
